import { render, staticRenderFns } from "./MessageTranslateDialog.vue?vue&type=template&id=3511e192&scoped=true"
import script from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageTranslateDialog.vue?vue&type=style&index=0&id=3511e192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3511e192",
  null
  
)

export default component.exports